module.exports = __webpack_public_path__ + "img/Day4_final.51b2e4cd.jpg";